import ContractActivity from './index';
import MatchConf from './matchConf';
import hashRateConfig from './hashRateConfig';

export default {
    path: '/home/hashrate',
    component: ContractActivity,
    redirect: '/home/hashrate/match-conf',
    children: [
        { path: '/home/hashrate/match-conf', component: MatchConf},
        { path: '/home/hashrate/hashRateConfig', component: hashRateConfig}
    ]
}